// extracted by mini-css-extract-plugin
export var isEb = "BasicTitle-module--is-eb--35e82";
export var title = "BasicTitle-module--title--b3292";